import { useState } from "react";
import { Check, Copy } from "lucide-react";

export function OpsCopyableReadonlyField(props: { label: string; value: string }) {
  const [copied, setCopied] = useState(false);
  const value = props.value.trim();

  async function copy() {
    if (!value) return;
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1400);
    } catch {
      /* ignore */
    }
  }

  return (
    <label className="block min-w-0 text-xs text-gray-600 dark:text-zinc-300">
      {props.label}
      <div className="mt-1 flex min-w-0 items-center gap-1">
        <input
          className="min-w-0 flex-1 truncate rounded border border-gray-300 bg-white px-2 py-1 font-mono text-xs dark:border-zinc-600 dark:bg-zinc-900"
          readOnly
          value={value}
          title={value}
        />
        <button
          type="button"
          disabled={!value}
          aria-label={copied ? "Copied" : `Copy ${props.label}`}
          className={`inline-flex shrink-0 items-center gap-1 rounded border px-2 py-1 text-xs transition-colors disabled:opacity-40 ${
            copied
              ? "border-emerald-500 bg-emerald-50 text-emerald-800 dark:border-emerald-600 dark:bg-emerald-950/40 dark:text-emerald-200"
              : "border-gray-300 text-gray-700 hover:bg-gray-50 dark:border-zinc-600 dark:text-zinc-200 dark:hover:bg-zinc-800"
          }`}
          onClick={() => void copy()}
        >
          {copied ? <Check className="h-3.5 w-3.5" aria-hidden /> : <Copy className="h-3.5 w-3.5" aria-hidden />}
          {copied ? "Copied" : "Copy"}
        </button>
      </div>
    </label>
  );
}
